// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3SsUB","productName":"Table_productName__spF1R"};